export default string => string.replace(/[^\w- ]/g, "").replace(/ /g, "_");
